import { render, staticRenderFns } from "./PublicitarioUserForm.vue?vue&type=template&id=0c033611"
import script from "./PublicitarioUserForm.vue?vue&type=script&lang=js"
export * from "./PublicitarioUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports